module.exports = __webpack_public_path__ + "static/img_2539_optimized-042a6531d242dac0454a2356642bdc72.jpg";